import { Button, Stack } from '@mui/material';

import WarningIcon from 'shared/icons/Warning';
import styled from 'shared/utils/styled';

export const NotificationDescription = styled('p')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontFamily: 'NeoSansStd',
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.primary.main,
  wordBreak: 'break-word',
}));

type NotificationProps = {
  onApply: () => void;
  onReject: () => void;
};

const Notification = ({ onApply, onReject }: NotificationProps) => {
  return (
    <Stack alignItems="center" spacing={3}>
      <WarningIcon sx={{ fontSize: '4rem', color: 'rgb(219, 118, 0)' }} />
      <NotificationDescription>
        Liitetyt tiedostot poistetaan mikäli tekstiviesti valitaan
        toimitustavaksi. Lähetetäänkö viesti tekstiviestinä?
      </NotificationDescription>
      <Stack direction="row" justifyContent="flex-end" width="100%" spacing={2}>
        <Button color="success" variant="contained" onClick={onApply}>
          Kyllä
        </Button>
        <Button color="primary" variant="contained" onClick={onReject}>
          Ei
        </Button>
      </Stack>
    </Stack>
  );
};

export default Notification;
